import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { LoadPinboardForTranslationDocument, useGetPinboardListQuery as _useGetPinboardListQuery, } from '../generated/graphql-types';
export const useGetPinboardListQuery = (params = {}, skip = false) => {
    const { data, error, loading } = _useGetPinboardListQuery({
        fetchPolicy: 'network-only',
        variables: { params },
        skip,
    });
    return {
        data,
        error,
        loading,
    };
};
export const useFetchPinboardDetail = () => {
    const client = useApolloClient();
    const fetchPinboardDetail = useCallback(async (id) => {
        const loadResult = await client.mutate({
            mutation: LoadPinboardForTranslationDocument,
            variables: { id },
        });
        return {
            pinboard: loadResult.data?.Pinboard__load?.pinboard,
        };
    }, [client]);
    return { fetchPinboardDetail };
};
//# sourceMappingURL=pinboard-list-service.js.map